/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  PaginatedProblemsResponse,
  ProblemComplexityUpdate,
  ProblemCreate,
  ProblemDetail,
  ProblemRead,
  ProblemRejudgeSummary,
  ProblemUpdate,
  TagCreate,
  TagRead,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PaginatedProblemsResponseFromJSON,
    PaginatedProblemsResponseToJSON,
    ProblemComplexityUpdateFromJSON,
    ProblemComplexityUpdateToJSON,
    ProblemCreateFromJSON,
    ProblemCreateToJSON,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
    ProblemReadFromJSON,
    ProblemReadToJSON,
    ProblemRejudgeSummaryFromJSON,
    ProblemRejudgeSummaryToJSON,
    ProblemUpdateFromJSON,
    ProblemUpdateToJSON,
    TagCreateFromJSON,
    TagCreateToJSON,
    TagReadFromJSON,
    TagReadToJSON,
} from '../models/index';

export interface AddTagToProblemRequest {
    problemId: string;
    tagId: string;
}

export interface CreateProblemRequest {
    problemCreate: ProblemCreate;
    tagIds?: Array<string>;
}

export interface CreateTagRequest {
    tagCreate: TagCreate;
}

export interface DeleteProblemRequest {
    problemId: string;
}

export interface GetProblemRequest {
    problemId: string;
}

export interface GetProblemRejudgeSummaryRequest {
    problemId: string;
}

export interface GetProblemsRequest {
    skip?: number;
    limit?: number;
    competitionId?: string | null;
    search?: string | null;
    tags?: string | null;
    problemType?: string | null;
}

export interface PrepareProblemRequest {
    problemId: string;
}

export interface RejudgeProblemRequest {
    problemId: string;
}

export interface RemoveTagFromProblemRequest {
    problemId: string;
    tagId: string;
}

export interface UpdateProblemRequest {
    problemId: string;
    problemUpdate: ProblemUpdate;
    tagIds?: Array<string> | null;
}

export interface UpdateProblemComplexityRequest {
    problemId: string;
    problemComplexityUpdate: ProblemComplexityUpdate;
}

/**
 * 
 */
export class ProblemsApi extends runtime.BaseAPI {

    /**
     * Add a tag to a problem.  **Authorization:** Only administrators can add tags to problems.  Args:     problem_id: ID of problem     tag_id: ID of tag to add     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated problem with tags  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not an administrator     HTTPException: 404 if problem or tag not found     HTTPException: 400 if tag already assigned
     * Add Tag To Problem
     */
    async addTagToProblemRaw(requestParameters: AddTagToProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemRead>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling addTagToProblem().'
            );
        }

        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling addTagToProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}/tags/{tag_id}`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))).replace(`{${"tag_id"}}`, encodeURIComponent(String(requestParameters['tagId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemReadFromJSON(jsonValue));
    }

    /**
     * Add a tag to a problem.  **Authorization:** Only administrators can add tags to problems.  Args:     problem_id: ID of problem     tag_id: ID of tag to add     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated problem with tags  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not an administrator     HTTPException: 404 if problem or tag not found     HTTPException: 400 if tag already assigned
     * Add Tag To Problem
     */
    async addTagToProblem(requestParameters: AddTagToProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemRead> {
        const response = await this.addTagToProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new problem.  **Authorization:** Only Content Creators or Competition Organizers can create problems.  Args:     problem: Problem data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)     tag_ids: Optional list of tag IDs to associate with problem  Returns:     Created problem with tags, without the solution fields  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user does not have Content Creator or Competition Organizer role     HTTPException: 404 if a tag ID is not found     HTTPException: 422 if complexity is out of range (schema validation)
     * Create Problem
     */
    async createProblemRaw(requestParameters: CreateProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemRead>> {
        if (requestParameters['problemCreate'] == null) {
            throw new runtime.RequiredError(
                'problemCreate',
                'Required parameter "problemCreate" was null or undefined when calling createProblem().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tagIds'] != null) {
            queryParameters['tag_ids'] = requestParameters['tagIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProblemCreateToJSON(requestParameters['problemCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemReadFromJSON(jsonValue));
    }

    /**
     * Create a new problem.  **Authorization:** Only Content Creators or Competition Organizers can create problems.  Args:     problem: Problem data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)     tag_ids: Optional list of tag IDs to associate with problem  Returns:     Created problem with tags, without the solution fields  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user does not have Content Creator or Competition Organizer role     HTTPException: 404 if a tag ID is not found     HTTPException: 422 if complexity is out of range (schema validation)
     * Create Problem
     */
    async createProblem(requestParameters: CreateProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemRead> {
        const response = await this.createProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new tag.  **Authorization:** Only administrators can create tags.  Args:     tag: Tag data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Created tag  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not an administrator     HTTPException: 400 if tag name already exists
     * Create Tag
     */
    async createTagRaw(requestParameters: CreateTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TagRead>> {
        if (requestParameters['tagCreate'] == null) {
            throw new runtime.RequiredError(
                'tagCreate',
                'Required parameter "tagCreate" was null or undefined when calling createTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TagCreateToJSON(requestParameters['tagCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TagReadFromJSON(jsonValue));
    }

    /**
     * Create a new tag.  **Authorization:** Only administrators can create tags.  Args:     tag: Tag data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Created tag  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not an administrator     HTTPException: 400 if tag name already exists
     * Create Tag
     */
    async createTag(requestParameters: CreateTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TagRead> {
        const response = await this.createTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a problem.  **Authorization:** Only problem owner can delete.  Args:     problem_id: ID of problem to delete     session: Database session (injected)     current_user: Currently authenticated user (injected)  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem not found
     * Delete Problem
     */
    async deleteProblemRaw(requestParameters: DeleteProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling deleteProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a problem.  **Authorization:** Only problem owner can delete.  Args:     problem_id: ID of problem to delete     session: Database session (injected)     current_user: Currently authenticated user (injected)  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem not found
     * Delete Problem
     */
    async deleteProblem(requestParameters: DeleteProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProblemRaw(requestParameters, initOverrides);
    }

    /**
     * Get a single problem by ID.  **Authorization:** All authenticated users can view public problems. `solution_code` and `extra_code` are returned only to the owner and to users with the administrator, content creator or competition organizer role; every other caller receives them as null.  Args:     problem_id: ID of problem to retrieve     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Problem with test case count and tags  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 404 if problem not found
     * Get Problem
     */
    async getProblemRaw(requestParameters: GetProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemDetail>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling getProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemDetailFromJSON(jsonValue));
    }

    /**
     * Get a single problem by ID.  **Authorization:** All authenticated users can view public problems. `solution_code` and `extra_code` are returned only to the owner and to users with the administrator, content creator or competition organizer role; every other caller receives them as null.  Args:     problem_id: ID of problem to retrieve     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Problem with test case count and tags  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 404 if problem not found
     * Get Problem
     */
    async getProblem(requestParameters: GetProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemDetail> {
        const response = await this.getProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Count the submissions a rejudge of the problem would cover: practice submissions and event submissions (ended events included). The confirmation of \"Ponovno ocijeni sve predaje\" names the count.  **Authorization:** the same rule as prepare: the problem owner with a licensed content creator or competition organizer role (or a superadmin owner).  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if the caller may not modify the problem (`LICENSE_REQUIRED` for an         owner whose authoring role sits only in unlicensed organizations)     HTTPException: 404 if problem not found
     * Get Problem Rejudge Summary
     */
    async getProblemRejudgeSummaryRaw(requestParameters: GetProblemRejudgeSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemRejudgeSummary>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling getProblemRejudgeSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}/rejudge`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemRejudgeSummaryFromJSON(jsonValue));
    }

    /**
     * Count the submissions a rejudge of the problem would cover: practice submissions and event submissions (ended events included). The confirmation of \"Ponovno ocijeni sve predaje\" names the count.  **Authorization:** the same rule as prepare: the problem owner with a licensed content creator or competition organizer role (or a superadmin owner).  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if the caller may not modify the problem (`LICENSE_REQUIRED` for an         owner whose authoring role sits only in unlicensed organizations)     HTTPException: 404 if problem not found
     * Get Problem Rejudge Summary
     */
    async getProblemRejudgeSummary(requestParameters: GetProblemRejudgeSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemRejudgeSummary> {
        const response = await this.getProblemRejudgeSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all problems, optionally filtered by competition, search terms, tags, or language.  **Authorization:** Any authenticated user can view problems. Items never include `solution_code` or `extra_code`; use GET /problems/{problem_id} for those.  Args:     session: Database session (injected)     current_user: Currently authenticated user (injected)     skip: Number of records to skip (for pagination)     limit: Maximum number of records to return (1-1000, default 100)     competition_id: Optional competition ID to filter by     search: Optional search term to match against problem name and statement     tags: Optional comma-separated list of tag names to filter by     language: Optional problem type to filter by (logo, algorithmic)  Returns:     Paginated response with problems, total count, skip, and limit  Raises:     HTTPException: 401 if user not authenticated
     * Get Problems
     */
    async getProblemsRaw(requestParameters: GetProblemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedProblemsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['competitionId'] != null) {
            queryParameters['competition_id'] = requestParameters['competitionId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        if (requestParameters['problemType'] != null) {
            queryParameters['problem_type'] = requestParameters['problemType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedProblemsResponseFromJSON(jsonValue));
    }

    /**
     * Get all problems, optionally filtered by competition, search terms, tags, or language.  **Authorization:** Any authenticated user can view problems. Items never include `solution_code` or `extra_code`; use GET /problems/{problem_id} for those.  Args:     session: Database session (injected)     current_user: Currently authenticated user (injected)     skip: Number of records to skip (for pagination)     limit: Maximum number of records to return (1-1000, default 100)     competition_id: Optional competition ID to filter by     search: Optional search term to match against problem name and statement     tags: Optional comma-separated list of tag names to filter by     language: Optional problem type to filter by (logo, algorithmic)  Returns:     Paginated response with problems, total count, skip, and limit  Raises:     HTTPException: 401 if user not authenticated
     * Get Problems
     */
    async getProblems(requestParameters: GetProblemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedProblemsResponse> {
        const response = await this.getProblemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available tags.  **Authorization:** Any authenticated user can view tags.  Args:     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     List of all tags  Raises:     HTTPException: 401 if user not authenticated
     * Get Tags
     */
    async getTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TagRead>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TagReadFromJSON));
    }

    /**
     * Get all available tags.  **Authorization:** Any authenticated user can view tags.  Args:     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     List of all tags  Raises:     HTTPException: 401 if user not authenticated
     * Get Tags
     */
    async getTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TagRead>> {
        const response = await this.getTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Initialize test cases for a problem by running solution code and generating official outputs.  This endpoint triggers a background Celery task that: 1. Runs the problem\'s solution code with each test case\'s driver code 2. Generates official output (text and images) for each test case 3. Updates test case status to INITIALIZED  **Authorization:** Only the problem owner, the same rule as update and delete.  Args:     problem_id: ID of problem to prepare     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Confirmation message that task was queued  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem not found     HTTPException: 422 if problem is not evaluatable
     * Prepare Problem
     */
    async prepareProblemRaw(requestParameters: PrepareProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling prepareProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}/prepare`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Initialize test cases for a problem by running solution code and generating official outputs.  This endpoint triggers a background Celery task that: 1. Runs the problem\'s solution code with each test case\'s driver code 2. Generates official output (text and images) for each test case 3. Updates test case status to INITIALIZED  **Authorization:** Only the problem owner, the same rule as update and delete.  Args:     problem_id: ID of problem to prepare     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Confirmation message that task was queued  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem not found     HTTPException: 422 if problem is not evaluatable
     * Prepare Problem
     */
    async prepareProblem(requestParameters: PrepareProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.prepareProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Queue every submission of a prepared problem, practice and event (ended events included), to be evaluated and judged again against the current test cases (#255). Answers with the counts that were queued; the judging runs in the background.  **Authorization:** the same rule as prepare.  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if the caller may not modify the problem (`LICENSE_REQUIRED` for an         owner whose authoring role sits only in unlicensed organizations)     HTTPException: 404 if problem not found     HTTPException: 409 if the problem has no test case or one is not prepared     HTTPException: 422 if the problem type is not evaluatable
     * Rejudge Problem
     */
    async rejudgeProblemRaw(requestParameters: RejudgeProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemRejudgeSummary>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling rejudgeProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}/rejudge`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemRejudgeSummaryFromJSON(jsonValue));
    }

    /**
     * Queue every submission of a prepared problem, practice and event (ended events included), to be evaluated and judged again against the current test cases (#255). Answers with the counts that were queued; the judging runs in the background.  **Authorization:** the same rule as prepare.  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if the caller may not modify the problem (`LICENSE_REQUIRED` for an         owner whose authoring role sits only in unlicensed organizations)     HTTPException: 404 if problem not found     HTTPException: 409 if the problem has no test case or one is not prepared     HTTPException: 422 if the problem type is not evaluatable
     * Rejudge Problem
     */
    async rejudgeProblem(requestParameters: RejudgeProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemRejudgeSummary> {
        const response = await this.rejudgeProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a tag from a problem.  **Authorization:** Only administrators can remove tags from problems.  Args:     problem_id: ID of problem     tag_id: ID of tag to remove     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated problem with tags  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not an administrator     HTTPException: 404 if problem, tag, or association not found
     * Remove Tag From Problem
     */
    async removeTagFromProblemRaw(requestParameters: RemoveTagFromProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemRead>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling removeTagFromProblem().'
            );
        }

        if (requestParameters['tagId'] == null) {
            throw new runtime.RequiredError(
                'tagId',
                'Required parameter "tagId" was null or undefined when calling removeTagFromProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}/tags/{tag_id}`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))).replace(`{${"tag_id"}}`, encodeURIComponent(String(requestParameters['tagId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemReadFromJSON(jsonValue));
    }

    /**
     * Remove a tag from a problem.  **Authorization:** Only administrators can remove tags from problems.  Args:     problem_id: ID of problem     tag_id: ID of tag to remove     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated problem with tags  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not an administrator     HTTPException: 404 if problem, tag, or association not found
     * Remove Tag From Problem
     */
    async removeTagFromProblem(requestParameters: RemoveTagFromProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemRead> {
        const response = await this.removeTagFromProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing problem.  **Authorization:** Only problem owner can update.  Args:     problem_id: ID of problem to update     problem_update: Updated problem data     session: Database session (injected)     current_user: Currently authenticated user (injected)     tag_ids: Optional list of tag IDs to replace existing tags  Returns:     Updated problem with tags, without the solution fields  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem or a tag ID not found     HTTPException: 400 if the ID in the URL does not match the body     HTTPException: 422 if complexity is out of range (schema validation)
     * Update Problem
     */
    async updateProblemRaw(requestParameters: UpdateProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemRead>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling updateProblem().'
            );
        }

        if (requestParameters['problemUpdate'] == null) {
            throw new runtime.RequiredError(
                'problemUpdate',
                'Required parameter "problemUpdate" was null or undefined when calling updateProblem().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tagIds'] != null) {
            queryParameters['tag_ids'] = requestParameters['tagIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProblemUpdateToJSON(requestParameters['problemUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemReadFromJSON(jsonValue));
    }

    /**
     * Update an existing problem.  **Authorization:** Only problem owner can update.  Args:     problem_id: ID of problem to update     problem_update: Updated problem data     session: Database session (injected)     current_user: Currently authenticated user (injected)     tag_ids: Optional list of tag IDs to replace existing tags  Returns:     Updated problem with tags, without the solution fields  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem or a tag ID not found     HTTPException: 400 if the ID in the URL does not match the body     HTTPException: 422 if complexity is out of range (schema validation)
     * Update Problem
     */
    async updateProblem(requestParameters: UpdateProblemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemRead> {
        const response = await this.updateProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change only the complexity rating of a problem.  **Authorization:** Only problem owner can change it.  Args:     problem_id: ID of the problem     data: New complexity (1 to 1000)     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated problem, without the solution fields  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem not found     HTTPException: 422 if complexity is out of range (schema validation)
     * Update Problem Complexity
     */
    async updateProblemComplexityRaw(requestParameters: UpdateProblemComplexityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProblemRead>> {
        if (requestParameters['problemId'] == null) {
            throw new runtime.RequiredError(
                'problemId',
                'Required parameter "problemId" was null or undefined when calling updateProblemComplexity().'
            );
        }

        if (requestParameters['problemComplexityUpdate'] == null) {
            throw new runtime.RequiredError(
                'problemComplexityUpdate',
                'Required parameter "problemComplexityUpdate" was null or undefined when calling updateProblemComplexity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/problems/{problem_id}/complexity`.replace(`{${"problem_id"}}`, encodeURIComponent(String(requestParameters['problemId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProblemComplexityUpdateToJSON(requestParameters['problemComplexityUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProblemReadFromJSON(jsonValue));
    }

    /**
     * Change only the complexity rating of a problem.  **Authorization:** Only problem owner can change it.  Args:     problem_id: ID of the problem     data: New complexity (1 to 1000)     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated problem, without the solution fields  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user is not the problem owner     HTTPException: 404 if problem not found     HTTPException: 422 if complexity is out of range (schema validation)
     * Update Problem Complexity
     */
    async updateProblemComplexity(requestParameters: UpdateProblemComplexityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProblemRead> {
        const response = await this.updateProblemComplexityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
